var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerRequisitionPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "52px",
    viewBox: "0 0 30 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker-requisition-pickup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Marker-/-Requisition-Pickup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9797645,1.00046043 C15.205206,0.990213087 15.4102815,1.12998082 15.623676,1.32176687 L15.623676,1.32176687 L22.6882489,8.3803872 C22.8422566,8.53439495 22.9512217,8.69671925 22.9867619,8.88152817 C23.0245803,9.07818352 22.9810307,9.28708654 22.8916291,9.51059051 C22.8097064,9.71539734 22.7070594,9.88302114 22.5593834,9.99377817 L22.5593834,9.99377817 L18.1161135,10.1581105 L18.1170343,13.3426362 C21.3922521,14.075533 24.2314875,15.9397702 26.1886228,18.4967719 C27.9533593,20.802404 29,23.6720164 29,26.7826087 C29,31.9624999 24.2445167,39.845697 14.9991129,50.4798558 C5.75488737,39.844709 1,31.9621753 1,26.7826087 C1,23.6720164 2.04664073,20.802404 3.81137716,18.4967719 C5.7685125,15.9397702 8.60774792,14.075533 11.8829657,13.3426362 L11.8829657,13.3426362 L11.8838871,10.1562316 L8.04879483,10.1562316 C7.82219651,10.1562316 7.62378463,10.1194951 7.46530625,10.0114417 C7.30421687,9.901608 7.1947537,9.72654759 7.10837087,9.51059051 C7.02360547,9.29867702 6.98036649,9.10014466 7.00801576,8.91232026 L7.00801576,8.91232026 L14.2629563,1.42918203 C14.5026919,1.18944639 14.7290017,1.01185874 14.9797645,1.00046043 Z",
    id: "Combined-Shape",
    stroke: "#1F5BC0",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1F5BC0",
    cx: 15,
    cy: 27,
    r: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerRequisitionPickup);
export default __webpack_public_path__ + "static/media/map-marker-requisition-pickup.398fa60ad0def56da6502d85ce01a949.svg";
export { ForwardRef as ReactComponent };